import { render, staticRenderFns } from "./BarManYiDu.vue?vue&type=template&id=4f10aed3&scoped=true"
import script from "./BarManYiDu.vue?vue&type=script&lang=js"
export * from "./BarManYiDu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f10aed3",
  null
  
)

export default component.exports